/*    
<summary>
  This functional component "AccountingPopupHOC" provides props to the child component.
  1. State "showAccountingPopup" that manages the show/hide of pop up
  2. Function "accountingPopupToggleHandler" to toggle the show/hide popup state "showAccountingPopup"
  Developer:Aashish Singh, Created Date:29-August-2023
</summary>
<returns>Returns JSX</returns>
*/
import React, { useState } from "react";

const AccountingPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showAccountingPopup, setShowAccountingPopup] = useState<boolean>(false);

    const accountingPopupToggleHandler = () => {
      setShowAccountingPopup(!showAccountingPopup);
    };

    return (
      <Component
        showAccountingPopup={showAccountingPopup}
        accountingPopupToggleHandler={accountingPopupToggleHandler}
        {...props}
      />
    );
  };

export default AccountingPopupHOC;
